<template>
    <div class="ad-video-container" :class="scene">
        <video ref="videoPlayer" class="video-js vjs-big-play-centered" preload="auto" controls="controls">
            <source :src="advertise.uri[0]" type="video/mp4">
        </video>
    </div>
</template>
<script>
import 'video.js/dist/video-js.css';
import videojs from 'video.js';
import { videoChinese } from '../../../utils/common';
export default {
    name: 'article-element',
    props: {
        advertise: {
            type: Object,
            required: true
        },
        scene: String,
    },
    data() {
        return {
            player: null,
            options: {
                language: 'zh-CN',
            }
        }
    },
    beforeMount() {
        videojs.addLanguage('zh-CN', videoChinese);
    },
    mounted() {      
        this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {}); 
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    }
}
</script>
<style scoped>
.ad-video-container {
    width: 550px;
    height: 210px;
    margin: 5px auto;
}

.ad-video-container.feedDetail {
    height: 310px;
}

.ad-video-container .video-js {
    width: 100%; 
    height: 100%;
}
</style>